var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "recipe-table"
  }, [_vm.finalRecipe && _vm.finalRecipe.detail && _vm.finalRecipe._id ? _c('Table', {
    attrs: {
      "columns": _vm.dynamicColumns,
      "data": _vm.displayData,
      "size": "small",
      "border": ""
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function (_ref) {
        var row = _ref.row;
        return [row.type === 'semi' ? _c('span', [_vm._v(_vm._s(row.model))]) : _c('span', {
          staticClass: "span-name"
        }, [_vm._v(_vm._s(row.name))])];
      }
    }, {
      key: "ratio",
      fn: function (_ref2) {
        var row = _ref2.row,
          index = _ref2.index;
        return [row.type === 'sumrow' ? _c('span', {
          class: {
            sumratio: true,
            'sumratio-alert': _vm.sumRatio > 100,
            'sumratio-nice': _vm.sumRatio === 100
          }
        }, [_vm._v(_vm._s(row.ratio))]) : _vm.mode.ratio.edit ? _c('InputNumber', {
          staticClass: "input-ratio",
          attrs: {
            "max": 100,
            "min": 0,
            "step": 0.1
          },
          model: {
            value: _vm.finalRecipe.detail[index].ratio,
            callback: function ($$v) {
              _vm.$set(_vm.finalRecipe.detail[index], "ratio", $$v);
            },
            expression: "finalRecipe.detail[index].ratio"
          }
        }) : _c('span', {
          staticClass: "span-ratio",
          staticStyle: {
            "line-height": "32px"
          }
        }, [_vm._v(_vm._s((_vm.finalRecipe.detail[index].ratio * 100).toFixed(2)))]), _c('span', {
          staticClass: "percentage-append"
        }, [_vm._v("%")])];
      }
    }, {
      key: "deleteBtn",
      fn: function (_ref3) {
        var row = _ref3.row;
        return [row.type !== 'sumrow' ? _c('Icon', {
          staticClass: "deleteBtn",
          attrs: {
            "type": "ios-remove-circle-outline",
            "size": "24"
          },
          on: {
            "click": function ($event) {
              return _vm.removeMaterialfromRecipe(row._id);
            }
          }
        }) : _vm._e()];
      }
    }, {
      key: "volPlan",
      fn: function (_ref4) {
        var row = _ref4.row,
          index = _ref4.index;
        return [row.type === 'sumrow' ? _c('span', {
          class: {
            sumratio: true
          }
        }, [_vm._v(_vm._s(_vm.totalQuantity))]) : _vm.mode.volPlan.edit ? _c('InputNumber', {
          attrs: {
            "max": 100,
            "min": 0,
            "step": 0.1
          },
          model: {
            value: _vm.finalRecipe.detail[index].volPlan,
            callback: function ($$v) {
              _vm.$set(_vm.finalRecipe.detail[index], "volPlan", $$v);
            },
            expression: "finalRecipe.detail[index].volPlan"
          }
        }) : _c('span', {
          staticClass: "span-ratio",
          staticStyle: {
            "line-height": "32px"
          }
        }, [_vm._v(_vm._s((_vm.finalRecipe.detail[index].ratio * _vm.totalQuantity).toFixed(2)))])];
      }
    }], null, false, 3845618049)
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }